import { createBrowserRouter, Navigate, Outlet } from 'react-router';
import { SesionProvider } from '@/shared/sesion/SesionProvider';
import { Armazon } from '@/shared/layout/Armazon';
import { RutaProtegida } from '@/shared/layout/RutaProtegida';
import { PaginaAcceso } from '@/modules/auth/PaginaAcceso';
import { PaginaUsuarios } from '@/modules/identidad/PaginaUsuarios';
import { PaginaRoles } from '@/modules/identidad/PaginaRoles';
import { PaginaMenu } from '@/modules/identidad/PaginaMenu';
import { DisposicionDeConfiguracion } from '@/modules/configuracion/DisposicionDeConfiguracion';
import { PaginaEmpresa } from '@/modules/configuracion/PaginaEmpresa';
import { PaginaComprobantes } from '@/modules/configuracion/PaginaComprobantes';
import { PaginaDocumentos } from '@/modules/configuracion/PaginaDocumentos';
import { PaginaEmision } from '@/modules/configuracion/PaginaEmision';
import { PaginaCorreo } from '@/modules/configuracion/PaginaCorreo';
import { PaginaDinardap } from '@/modules/configuracion/PaginaDinardap';
import { PaginaFeriados } from '@/modules/configuracion/PaginaFeriados';
import { PaginaPuntosEmision } from '@/modules/configuracion/PaginaPuntosEmision';
import { PaginaEmisionMensual } from '@/modules/facturacion/PaginaEmision';
import { PaginaCartera } from '@/modules/facturacion/PaginaCartera';
import { PaginaCobros } from '@/modules/recaudacion/PaginaCobros';
import { PaginaRegistroDeCobros } from '@/modules/recaudacion/PaginaRegistroDeCobros';
import { PaginaAperturaDeCaja } from '@/modules/recaudacion/PaginaAperturaDeCaja';
import { PaginaCierreDeCaja } from '@/modules/recaudacion/PaginaCierreDeCaja';
import { PaginaConsultaDeDeuda } from '@/modules/facturacion/PaginaConsultaDeDeuda';
import { PaginaFacturas } from '@/modules/facturacion/PaginaFacturas';
import { PaginaProcesoSri } from '@/modules/facturacion/PaginaProcesoSri';
import { PaginaDescargas } from '@/modules/facturacion/PaginaDescargas';
import { PaginaNotasDeCredito } from '@/modules/facturacion/PaginaNotasDeCredito';
import { PaginaMapa } from '@/modules/catastro/PaginaMapa';
import { PaginaImportarCatastro } from '@/modules/catastro/PaginaImportarCatastro';
import { PaginaAuditoria } from '@/modules/auditoria/PaginaAuditoria';
import { PaginaReportes } from '@/modules/reportes/PaginaReportes';
import { PaginaFacturasAnuladas } from '@/modules/facturacion/PaginaFacturasAnuladas';
import { PaginaClientes } from '@/modules/catastro/PaginaClientes';
import { PaginaParroquias } from '@/modules/catastro/PaginaParroquias';
import { PaginaDetalleDeCliente } from '@/modules/catastro/PaginaDetalleDeCliente';
import { PaginaTarifas } from '@/modules/tarifario/PaginaTarifas';
import { PaginaCategoriasTarifarias } from '@/modules/tarifario/PaginaCategoriasTarifarias';
import { PaginaConceptos } from '@/modules/tarifario/PaginaConceptos';
import { PaginaMotivosDeCorreccion } from '@/modules/facturacion/PaginaMotivosDeCorreccion';
import { PaginaExoneraciones } from '@/modules/tarifario/PaginaExoneraciones';
import { PaginaTiposDeExoneracion } from '@/modules/tarifario/PaginaTiposDeExoneracion';
import { PaginaTasasDeMora } from '@/modules/tarifario/PaginaTasasDeMora';
import { PaginaInicio } from '@/modules/inicio/PaginaInicio';
import { PaginaApiPublica } from '@/modules/apipublica/PaginaApiPublica';
import { PaginaProveedores } from '@/modules/compras/PaginaProveedores';
import { PaginaConceptosDeRetencion } from '@/modules/compras/PaginaConceptosDeRetencion';
import { PaginaCompras } from '@/modules/compras/PaginaCompras';
import { PaginaRetenciones } from '@/modules/compras/PaginaRetenciones';
import { PaginaCatalogosTributarios } from '@/modules/compras/PaginaCatalogosTributarios';
import { PaginaRecaudacionDeCooperativas } from '@/modules/apipublica/PaginaRecaudacionDeCooperativas';
import { PaginaTitulos } from '@/modules/titulos/PaginaTitulos';
import { PaginaConvenios } from '@/modules/convenios/PaginaConvenios';
import { PaginaGeneradores } from '@/modules/generadores/PaginaGeneradores';
import { PaginaControlDePesaje } from '@/modules/generadores/PaginaControlDePesaje';
import { PaginaFacturacionDeGeneradores } from '@/modules/generadores/PaginaFacturacionDeGeneradores';
import { PaginaCargosPuntuales } from '@/modules/generadores/PaginaCargosPuntuales';
import { PaginaPreguntasFrecuentes } from '@/modules/portal/PaginaPreguntasFrecuentes';
import { PaginaBanners } from '@/modules/portal/PaginaBanners';
import { PaginaPieDePagina } from '@/modules/portal/PaginaPieDePagina';
import { PaginaDocumentosLegales } from '@/modules/portal/PaginaDocumentosLegales';
import { PaginaFirmaElectronica } from '@/modules/firma/PaginaFirmaElectronica';
import { PaginaCertificados } from '@/modules/certificados/PaginaCertificados';
import { PaginaDeMonitoreo } from '@/modules/pagosenlinea/PaginaDeMonitoreo';
import { PaginaPagosEnLinea } from '@/modules/pagosenlinea/PaginaPagosEnLinea';
import { PaginaPasarelasDePago } from '@/modules/pagosenlinea/PaginaPasarelasDePago';
import { PaginaEnConstruccion } from '@/shared/ui/PaginaEnConstruccion';

export const rutas = createBrowserRouter([
  {
    element: (
      <SesionProvider>
        <Outlet />
      </SesionProvider>
    ),
    children: [
      { path: '/acceso', element: <PaginaAcceso /> },
      {
        element: <RutaProtegida />,
        children: [
          {
            path: '/',
            element: <Armazon />,
            children: [
              { index: true, element: <Navigate to="/inicio" replace /> },
              { path: 'inicio', element: <PaginaInicio /> },
              { path: 'usuarios', element: <PaginaUsuarios /> },
              { path: 'roles', element: <PaginaRoles /> },
              { path: 'menu', element: <PaginaMenu /> },
              { path: 'puntos-emision', element: <PaginaPuntosEmision /> },
              { path: 'emision', element: <PaginaEmisionMensual /> },
              { path: 'cartera', element: <PaginaCartera /> },
              { path: 'pagos', element: <PaginaCobros /> },
              { path: 'pagos/registro', element: <PaginaRegistroDeCobros /> },
              { path: 'apertura-caja', element: <PaginaAperturaDeCaja /> },
              { path: 'cierre-caja', element: <PaginaCierreDeCaja /> },
              { path: 'titulos', element: <PaginaTitulos /> },
              { path: 'convenios', element: <PaginaConvenios /> },
              { path: 'generadores', element: <PaginaGeneradores /> },
              { path: 'generadores/pesaje', element: <PaginaControlDePesaje /> },
              { path: 'generadores/facturacion', element: <PaginaFacturacionDeGeneradores /> },
              { path: 'generadores/cargos', element: <PaginaCargosPuntuales /> },
              { path: 'consulta-deuda', element: <PaginaConsultaDeDeuda /> },
              { path: 'facturas', element: <PaginaFacturas /> },
              { path: 'proceso-sri', element: <PaginaProcesoSri /> },
              { path: 'descargas', element: <PaginaDescargas /> },
              { path: 'notas-credito', element: <PaginaNotasDeCredito /> },
              { path: 'facturas/anuladas', element: <PaginaFacturasAnuladas /> },
              { path: 'clientes', element: <PaginaClientes /> },
              { path: 'parroquias', element: <PaginaParroquias /> },
              { path: 'clientes/:id', element: <PaginaDetalleDeCliente /> },
              { path: 'mapa', element: <PaginaMapa /> },
              { path: 'importar', element: <PaginaImportarCatastro /> },
              { path: 'auditoria', element: <PaginaAuditoria /> },
              { path: 'api-publica', element: <PaginaApiPublica /> },
              { path: 'proveedores', element: <PaginaProveedores /> },
              { path: 'retenciones', element: <PaginaConceptosDeRetencion /> },
              { path: 'compras', element: <PaginaCompras /> },
              { path: 'compras/catalogos', element: <PaginaCatalogosTributarios /> },
              { path: 'compras/retenciones', element: <PaginaRetenciones /> },
              { path: 'recaudacion-cooperativas', element: <PaginaRecaudacionDeCooperativas /> },
              { path: 'reportes', element: <PaginaReportes /> },
              { path: 'tarifas', element: <PaginaTarifas /> },
              { path: 'tarifas/categorias', element: <PaginaCategoriasTarifarias /> },
              { path: 'tarifas/mora', element: <PaginaTasasDeMora /> },

              { path: 'catalogos', element: <PaginaConceptos /> },
              {
                path: 'catalogos/motivos-de-correccion',
                element: <PaginaMotivosDeCorreccion />,
              },
              { path: 'exoneraciones', element: <PaginaExoneraciones /> },
              { path: 'exoneraciones/tipos', element: <PaginaTiposDeExoneracion /> },

              { path: 'portal/preguntas-frecuentes', element: <PaginaPreguntasFrecuentes /> },
              { path: 'portal/banners', element: <PaginaBanners /> },
              { path: 'portal/footer', element: <PaginaPieDePagina /> },
              { path: 'portal/documentos-legales', element: <PaginaDocumentosLegales /> },

              { path: 'portal/pasarelas', element: <PaginaPasarelasDePago /> },
              { path: 'firma-electronica', element: <PaginaFirmaElectronica /> },
              { path: 'certificados', element: <PaginaCertificados /> },
              { path: 'pagos-online', element: <PaginaPagosEnLinea /> },
              { path: 'pagos-online/monitoreo', element: <PaginaDeMonitoreo /> },
              {
                path: 'configuracion',
                element: <DisposicionDeConfiguracion />,
                children: [
                  { index: true, element: <PaginaEmpresa /> },
                  { path: 'emision', element: <PaginaEmision /> },
                  { path: 'feriados', element: <PaginaFeriados /> },
                  { path: 'comprobantes', element: <PaginaComprobantes /> },
                  { path: 'documentos', element: <PaginaDocumentos /> },
                  { path: 'correo', element: <PaginaCorreo /> },
                  { path: 'dinardap', element: <PaginaDinardap /> },
                ],
              },
              {
                path: '*',
                element: (
                  <PaginaEnConstruccion titulo="Aún no disponible" fase="una fase posterior" />
                ),
              },
            ],
          },
        ],
      },
    ],
  },
]);
